import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const AWARDS = [{
  name: 'US Search Awards',
  logo: 'https://cdn.magicpatterns.com/uploads/qd9j3FEwrEbXXB1faWdZQ3/us-search-awards-blue.png'
}, {
  name: 'Summit Creative Award',
  logo: 'https://cdn.magicpatterns.com/uploads/8K7aWitn8DttSDgbhMwJA1/sca-blue-02.png'
}, {
  name: 'The Finnys',
  logo: 'https://cdn.magicpatterns.com/uploads/u8j5EhK2YUiSzm9wN7srKJ/finnys-blue.png'
}, {
  name: 'Interactive Marketing Awards',
  logo: 'https://cdn.magicpatterns.com/uploads/khxJDgmjBvyBEmDSUyUHcU/interactive-marketing-blue.png'
}, {
  name: 'SCA International',
  logo: 'https://cdn.magicpatterns.com/uploads/3fWfQE2aPqXEDfPCNuSGaW/sca-blue.png'
}, {
  name: 'Web Excellence Awards',
  logo: 'https://cdn.magicpatterns.com/uploads/v5G9VGYiWzPp4V7iuegPWe/logo_wea_blue_nobg.png'
}, {
  name: 'Best of Region',
  logo: 'https://cdn.magicpatterns.com/uploads/7yLDVwWrS6Xpi2Htz2158S/post-star-best-of-region-award-small.png'
}];
function StarRow() {
  return <div className="flex items-center gap-0.5" aria-hidden="true" data-id="element-24" data-mp="i51jujvl3o2v">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-[var(--color-lime)] text-[var(--color-lime)]" data-id="element-25" data-mp="45s0jbc30duo" data-mpi={i} />)}
    </div>;
}
function AwardsCarousel() {
  const [activeIndex, setActiveIndex] = useState(0);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setActiveIndex(current => (current + 1) % AWARDS.length);
    }, 2500);
    return () => window.clearInterval(timer);
  }, []);
  const award = AWARDS[activeIndex];
  return <div className="sm:hidden" data-id="element-26" data-mp="n3bbiki3o6jq">
      <div className="relative flex h-28 items-center justify-center overflow-hidden rounded-xl border border-slate-200 bg-slate-50" data-id="element-27" data-mp="n2a20kgqfs44">
        <AnimatePresence mode="wait" data-id="element-28" data-mp="1fsa2860agh0n">
          <motion.img key={award.name} src={award.logo} alt={award.name} initial={{
          opacity: 0,
          x: 24
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: -24
        }} transition={{
          duration: 0.35,
          ease: 'easeOut'
        }} className="h-16 w-2/3 object-contain" data-id="element-29" data-mp="1fr769jo3zodv" />
        </AnimatePresence>
      </div>
      <div className="mt-4 flex items-center justify-center gap-2" role="tablist" aria-label="Awards" data-id="element-30" data-mp="1kfhtbinwm27d">
        {AWARDS.map((a, i) => <button key={a.name} type="button" role="tab" aria-selected={i === activeIndex} aria-label={a.name} onClick={() => setActiveIndex(i)} className={`h-2 rounded-full transition-all ${i === activeIndex ? 'w-6 bg-[var(--color-navy)]' : 'w-2 bg-slate-300 hover:bg-slate-400'}`} data-id="element-31" data-mp="1bgmly394im2h" data-mpi={i} />)}
      </div>
    </div>;
}
export function AwardsSection() {
  return <section className="w-full bg-white" data-id="element-32" data-mp="wsrs2jjdqbnt">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 sm:px-6 sm:py-16 lg:px-8" data-id="element-33" data-mp="wpvtqu3mdkyu">
        <h2 className="font-display text-center text-2xl font-bold text-[var(--color-navy)] sm:text-3xl" data-id="element-34" data-mp="spc0w2q2x3ii">
          Work with An Award-Winning Agency
        </h2>
        <div className="mt-10" data-id="element-35" data-mp="2zdcalizfx7x2">
          <AwardsCarousel data-id="element-36" data-mp="2ze48x1kf9jr1" />
          <div className="hidden sm:grid sm:grid-cols-4 sm:gap-6 lg:grid-cols-7" data-id="element-37" data-mp="34dgqb6sixym8">
            {AWARDS.map(award => <div key={award.name} className="flex flex-col items-center justify-center gap-3 rounded-xl border border-slate-200 bg-slate-50 px-3 py-6 text-center transition-shadow hover:shadow-md" data-id="element-38" data-mp="38fbs0cedae0j">
                <img src={award.logo} alt={award.name} className="h-14 w-full object-contain" data-id="element-39" data-mp="2go5ywfx2dgkr" />
              </div>)}
          </div>
        </div>
      </div>
      <div className="w-full bg-[var(--color-navy)]" data-id="element-40" data-mp="2kq0wpafsdbts">
        <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-center gap-6 px-4 py-8 sm:flex-row sm:gap-16 sm:px-6 lg:px-8" data-id="element-41" data-mp="2po2iw48idr9h">
          <div className="flex items-center gap-3" data-id="element-42" data-mp="2uglu4ujq4ab4">
            <span className="font-display text-lg font-bold text-white" data-id="element-43" data-mp="1x0gg2y73uqno">
              Google Rating
            </span>
            <StarRow data-id="element-44" data-mp="21xygg0723xk2" />
          </div>
          <div className="hidden h-8 w-px bg-white/20 sm:block" aria-hidden="true" data-id="element-45" data-mp="21wx1vlqu0sxl" />
          <div className="flex items-center gap-3" data-id="element-46" data-mp="8giz52dwwg6q">
            <span className="font-display text-lg font-bold text-white" data-id="element-47" data-mp="3hptfw4v9th4">
              Clutch Rating
            </span>
            <StarRow data-id="element-48" data-mp="h9mhnp3ezj88" />
          </div>
        </div>
      </div>
    </section>;
}